import { IUnclaimedProfile } from "MVVM/@types";
import { ProPlayerUpsell } from "./ProPlayerUpsell";
import { RegularUserUpsell } from "./RegularUserUpsell";

interface IClaimProfileUpsellProps {
  user: IUnclaimedProfile;
  onClose?: () => void;
}

export const ClaimProfileUpsell = ({
  user,
  onClose,
}: IClaimProfileUpsellProps) => {
  const proPlayer = user.proPlayer;

  if (proPlayer) {
    return <ProPlayerUpsell user={user} onClose={onClose} />;
  }

  return <RegularUserUpsell user={user} onClose={onClose} />;
};
